import States from './Lists/States';

const getQueryParam = (params, key) => {
  const entry = Array.from(params.entries())
    .find(([paramKey]) => paramKey.toLowerCase() === key.toLowerCase());

  return entry ? entry[1] : undefined;
};

const getNumberQueryParam = (params, key) => {
  const value = getQueryParam(params, key);

  if (value === undefined || value === '') {
    return null;
  }

  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? null : numberValue;
};

const getBooleanQueryParam = (params, key) => {
  const value = getQueryParam(params, key);

  if (value === undefined || value === '') {
    return null;
  }

  if (value.toLowerCase() === 'true') {
    return true;
  }

  if (value.toLowerCase() === 'false') {
    return false;
  }

  return value;
};

const getGender = (gender) => {
  switch (gender?.toLowerCase()) {
    case 'male':
    case 'm':
      return 'M';
    case 'female':
    case 'f':
      return 'F';
    default:
      return '';
  }
};

const getHealthClassCode = (healthClass) => {
  switch (healthClass?.toUpperCase()) {
    case 'EXCEPTIONALLY HEALTHY':
      return 'PP';
    case 'VERY HEALTHY':
    case 'SOMEWHAT HEALTHY':
      return 'P';
    case 'NOT AS HEALTHY':
      return 'R';
    default:
      return healthClass?.toUpperCase();
  }
};

const getStateCode = (state) => {
  if (!state) {
    return '';
  }

  const stateValue = state.toLowerCase();
  const stateMatch = States().find(({ label, value }) => (
    label.toLowerCase() === stateValue || value.toLowerCase() === stateValue
  ));

  return stateMatch?.value || state.toUpperCase();
};

const getHeightString = (totalInches) => {
  if (!totalInches) {
    return '';
  }

  return `${Math.floor(totalInches / 12)} ft ${totalInches % 12} in`;
};

const getWeightString = (weight) => weight ? `${weight} pounds` : '';

const buildClientInfo = (params) => {
  const weight = getNumberQueryParam(params, 'weight');
  const totalInches = getNumberQueryParam(params, 'totalInches');

  return {
    path: getQueryParam(params, 'path') || '',
    phone: getQueryParam(params, 'phone') || '',
    gender: getGender(getQueryParam(params, 'gender')),
    dateOfBirth: getQueryParam(params, 'dateOfBirth') || '',
    tobacco: getBooleanQueryParam(params, 'tobacco'),
    state: getStateCode(getQueryParam(params, 'state')),
    heightString: getHeightString(totalInches),
    totalInches,
    weightString: getWeightString(weight),
    weight,
    email: getQueryParam(params, 'email') || '',
    usResident: getBooleanQueryParam(params, 'usResident'),
    replacePolicy: getBooleanQueryParam(params, 'replacePolicy'),
    termLength: getNumberQueryParam(params, 'term_length'),
    faceAmount: getNumberQueryParam(params, 'faceAmount'),
    healthClass: getHealthClassCode(getQueryParam(params, 'healthClass')),
    firstName: getQueryParam(params, 'firstName') || '',
    lastName: getQueryParam(params, 'lastName') || '',
    income: getNumberQueryParam(params, 'income'),
  };
};

const buildDataImportRedirectUrl = (path, params) => {
  const redirectParams = new URLSearchParams();

  Array.from(params.entries())
    .filter(([key]) => key.toLowerCase().includes('utm_'))
    .forEach(([key, value]) => redirectParams.append(key, value));

  const utmQuery = redirectParams.toString();
  const separator = path.includes('?') ? '&' : '?';

  return `${path}${separator}${utmQuery ? `${utmQuery}&` : ''}DataImport`;
};

const getDataImportClientInfo = (queryString) => {
  const params = new URLSearchParams(queryString);
  const path = getQueryParam(params, 'path');

  if (!path) {
    return null;
  }

  return {
    clientInfo: buildClientInfo(params),
    redirectUrl: buildDataImportRedirectUrl(path, params),
  };
};

export default getDataImportClientInfo;
 